import { useSyncExternalStore } from "react";

function subscribeMinWidth(minWidthPx: number, onStoreChange: () => void) {
  if (typeof window === "undefined" || !window.matchMedia) {
    return () => {};
  }
  const mq = window.matchMedia(`(min-width: ${minWidthPx}px)`);
  mq.addEventListener("change", onStoreChange);
  return () => mq.removeEventListener("change", onStoreChange);
}

function getMinWidthSnapshot(minWidthPx: number): boolean {
  if (typeof window === "undefined" || !window.matchMedia) {
    return false;
  }
  return window.matchMedia(`(min-width: ${minWidthPx}px)`).matches;
}

/** Tailwind `2xl` breakpoint (1536px). */
export const SIDE_NAV_WIDE_BREAKPOINT_PX = 1536;

export function useMinWidth(minWidthPx: number): boolean {
  return useSyncExternalStore(
    (onStoreChange) => subscribeMinWidth(minWidthPx, onStoreChange),
    () => getMinWidthSnapshot(minWidthPx),
    () => false,
  );
}

export function shouldUseSideNavFlyout(sidebarCollapsed: boolean, isWideSidebar: boolean): boolean {
  return sidebarCollapsed || !isWideSidebar;
}
